import styled from 'styled-components'
import Box from 'web-makeup/dist/Box'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import Button from 'web-makeup/dist/Button'
import Input from 'web-makeup/dist/Input'
import Select from 'web-makeup/dist/Select'
import { Text } from 'web-makeup/dist/design-system/styles/typography'

import {
  CONTENT_MAX_WIDTH,
  MID_BREAKPOINT,
  SMALL_BREAKPOINT,
  XSMALL_BREAKPOINT,
  XXSMALL_BREAKPOINT,
  XXXSMALL_BREAKPOINT,
  LARGE_BREAKPOINT,
  placeholderColor,
} from '../../style'

export const Container = styled.div`
  max-width: 90rem;
  margin-bottom: 0.25rem;

  @media all and (max-width: ${MID_BREAKPOINT}) {
    margin-bottom: 0;
  }
`
export const Left = styled.div`
  width: 100%;
  padding-right: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media all and (max-width: ${MID_BREAKPOINT}) {
    display: none;
  }
`
export const Right = styled.div`
  min-width: 100%;

  @media all and (max-width: ${MID_BREAKPOINT}) {
    margin: 0 auto;
    min-width: auto;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    width: 100%;
  }
`
export const ContentHolder = styled(Box as any)`
  padding: 2.44rem 0 2.31rem;
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  max-width: 90rem;
  paddding: 0 6.25rem;
  && {
    border: 0;
  }

  @media all and (max-width: ${LARGE_BREAKPOINT}) {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  @media all and (max-width: ${MID_BREAKPOINT}) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`
export const WhiteBox = styled.div<{ padding?: string }>`
  background: white;
  color: white;
  padding: ${({ padding }) => (padding ? padding : `1.5rem 2rem`)};
  border: 1px solid ${colors.gandalf};
  border-radius: 12px;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    padding: 0.75rem 1rem;
  }
`
export const InnerBox = styled.div`
  max-width: 13rem;
  picture {
    text-align: center;
    display: block;
  }

  @media all and (max-width: ${MID_BREAKPOINT}) {
    margin: 0 auto;
    margin-bottom: 1.5rem;
  }
`
export const FooterFlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 48rem;
  margin: 0 auto 2.875rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
  }
`
export const StyledButton = styled(Button as any)`
  &&& {
    background: ${colors.adaptBlue};
    width: 100%;
    border-color: ${colors.adaptBlue};
    border-radius: 6.25rem;
    height: 3.75rem;
    font-size: 1rem;
  }

  &&&:disabled,
  &&&[disabled] {
    background: ${colors.radagast};
    color: white;
  }
`
export const StyledInput = styled(Input as any)<{ error?: boolean }>`
  &&& {
    border: 1px solid ${({ error }) => (error ? colors.alert : colors.radagast)};
    height: 2.75rem;
    font-size: 1rem;
    color: ${colors.black1};

    &:focus {
      border-color: ${colors.nebula};
      outline: none;
      box-shadow: none;
    }

    &.is-filled {
      background: ${colors.dust};
      border-color: ${colors.dust};
    }

    &[type='number'] {
      width: 17rem;
      /* stylelint-disable */
      -moz-appearance: textfield;

      @media all and (max-width: ${XXXSMALL_BREAKPOINT}) {
        width: 100%;
      }
    }

    &[type='number']::-webkit-outer-spin-button,
    &[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
      /* stylelint-enable */
      margin: 0;
    }

    ${placeholderColor(colors.nebula)};
  }
`
export const StyledSelect = styled(Select as any)`
  &&& {
    width: 100%;
    .ant-select-selection--single {
      border: 1px solid ${colors.radagast};
      height: 2.75rem;
      font-size: 1rem;
      color: ${colors.black1};
      width: 100%;
    }
  }
`
export const StyledLabel = styled.label`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
export const InputWrapper = styled.div`
  position: relative;
  button {
    position: absolute;
    right: 6px;
    top: 6px;
  }
`
export const StyledButtonAdd = styled(Button as any)`
  &&& {
    background: ${colors.saruman};
    height: 2rem;
    padding: 0 1rem;
    color: white;
    border-radius: 6.25rem;
  }
`
export const CheckboxInput = styled(Input as any)<{ showCheckedError?: boolean }>`
  &&& {
    display: none;
  }

  &&& + label {
    background: url(${({ showCheckedError }) =>
        showCheckedError
          ? `https://res.cloudinary.com/ninety-seconds/image/upload/v1666111178/-design-system/icon-checkbox-unselected-red.svg`
          : `https://res.cloudinary.com/ninety-seconds/image/upload/v1629708818/-design-system/icon-checkbox-unselected.svg`})
      no-repeat;
    width: 100%;
    margin-right: 0.5rem;
    padding-left: 1.75rem;
    cursor: pointer;
  }

  &&&:checked + label {
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1629708819/-design-system/icon-checkbox-selected.svg)
      no-repeat;
  }
`

export const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  color: ${colors.black1};
  cursor: pointer;
  font-size: 0.75rem;
  line-height: 1.25rem;

  input {
    margin-right: 0.5rem;
  }

  a {
    color: ${colors.adaptBlue};
    font-weight: 700;
    white-space: nowrap;
    display: inline-block;
  }
`
export const Hr = styled.div`
  border: 1px solid ${colors.gandalf};
  margin: 1.5rem 0;
`
export const MobileCalendarWrapper = styled.div`
  display: none;

  .ant-calendar-picker {
    width: 100%;

    input {
      border: 1px solid ${colors.radagast};
      height: 2.75rem;
      font-size: 1rem;
      color: ${colors.black1};
      cursor: pointer;
    }

    img {
      width: 16px;
    }

    &:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
      border-color: ${colors.radagast};
    }

    &.filled {
      input {
        background: ${colors.dust};
        border-color: ${colors.dust};
      }
    }
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
    margin-bottom: 1.5rem;
  }
`
export const CalendarWrapper = styled.div<{ showDateError?: boolean }>`
  color: ${colors.black1};
  ${({ showDateError }) => !showDateError && `margin-bottom: 0.5rem;`}

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: none;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 0.5rem;
  }

  .ant-fullcalendar-table {
    width: 100%;
    margin-top: 0.5rem;
    text-align: center;
    font-size: 0.75rem;
  }
  & > div {
    background: ${colors.dust};
    padding: 0.75rem;
    max-width: 15rem;
    font-size: 0.75rem;
    line-height: 2;
    border-radius: 0.5rem;
    ${({ showDateError }) => showDateError && `border: 1px solid ${colors.alert};`}

    @media all and (max-width: ${XXXSMALL_BREAKPOINT}) {
      max-width: auto;
    }
  }
  .react-calendar__tile--rangeStart {
    background: ${colors.adaptBlue};
    color: white;
    font-weight: 700;
  }
  .react-calendar__tile {
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    padding: 0;
    /* stylelint-disable */
    max-width: 2rem !important;
    /* stylelint-enable */

    &:hover {
      background: ${colors.adaptBlue};
      color: white;
    }

    &.react-calendar__year-view__months__month,
    &.react-calendar__decade-view__years__year,
    &.react-calendar__century-view__decades__decade {
      border-radius: 3px;
    }

    &:disabled,
    &[disabled] {
      color: ${colors.dawn};
      &:hover {
        background: none;
        color: ${colors.dawn};
      }
    }
  }

  .react-calendar__month-view__weekdays__weekday {
    font-weight: 700;
    font-size: 10px;
    line-height: 12px;
    color: ${colors.black1};
    text-transform: uppercase;
    display: flex;
    justify-content: center;

    abbr {
      text-decoration: none;
    }
  }
`
export const FormFlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  > div:first-of-type {
    flex: 1;
    padding-right: 1.5rem;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: flex;
    margin-bottom: 1.5rem;
    flex-direction: column-reverse;

    > div:first-of-type {
      padding-right: 0;
    }
  }
`
export const TalkButton = styled(Button as any)`
  &&& {
    border-radius: 6.25rem;
    background: ${colors.adaptBlue};
    height: 3.25rem;
    font-size: 1rem;
    padding: 0 3.25rem;
  }
`
export const SmallTitle = styled.div`
  font-weight: 900;
  font-size: 2.75rem;
  line-height: 3.25rem;
  color: ${colors.black1};
  margin-bottom: 0.75rem;
`
export const SmallDescription = styled.div`
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.75rem;
  color: ${colors.black1};
  margin-bottom: 1.5rem;
  max-width: 39rem;
`
export const H1 = styled.h1`
  font-weight: 900;
  font-size: 2.75rem;
  line-height: 3.625rem;
  margin-bottom: 0.5rem;
  text-align: center;
  display: none;
  color: ${colors.black1};

  @media all and (max-width: ${MID_BREAKPOINT}) {
    display: block;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    font-size: 2rem;
    margin-bottom: 0.25rem;
    line-height: 2.875rem;
  }
`
export const Paragraph = styled.p`
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-bottom: 1.5rem;
  text-align: center;
  display: none;
  color: ${colors.black1};

  @media all and (max-width: ${MID_BREAKPOINT}) {
    display: block;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    font-size: 1rem;
    margin-bottom: 0.75rem;
    line-height: 1.625rem;
  }
`
export const DueDateValue = styled(Text as any)`
  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/PurchaseRedesigned/PurchaseRedesigned.style.tsx